import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_12: FaireProductEntity = {
  token: "viverano-12",
  type: "product",
  name: "Savannah-Organic 3D Jacquard Sweater Knit Baby Blanket",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/6f1712b78b2008516ebd1f23c21945680e3e202ea3328df1179a61e5f22ed121.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1750,1750,x136,y119,safe&width=720",
  priceDollars: 40,
  msrpDollars: 70,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_nursery-decor"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
